import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import AddInventTypeForm from "../AddInventTypeForm";
import { createResourceType } from "../../../store/send";

const styles = () => ({
  dialog: {
    width: "550px"
  }
});

const AddInventTypeModal = ({
  open,
  handleClose,
  createResourceType,
  isCreatingResType,
  createdResType,
  classes,
  resourceTypeList
}) => {
  const [formData, updateFormData] = useState(null);

  const onConfirm = () => {
    createResourceType(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  useEffect(() => {
    if (createdResType && createdResType.success) {
      updateFormData(null);
      handleClose();
    }
  }, [createdResType, handleClose]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Добавить тип ресурса</DialogTitle>
        <DialogContent>
          <AddInventTypeForm
            onFormChange={updateFormData}
            disabled={isCreatingResType}
            inventTypesList={resourceTypeList}
            //getInventTypes={getInventTypes}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingResType}
            disabled={isCreatingResType}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  isCreatingResType: state.nomenclature.isCreatingResType,
  createdResType: state.nomenclature.createdResType,
  resourceTypeList: state.nomenclature.restypes
});

const mapDispatchToProps = dispatch => ({
  createResourceType: data => dispatch(createResourceType(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(AddInventTypeModal)));
